import React from "react";
import { useTranslation } from "react-i18next";

import FormikDropzoneField from "components/InputsField/formikInputs/FormikDropzoneField";
import FormRow from "components/common/Layout/FormRow";
import Title from "components/common/Layout/Title";

export default function CargoDocuments() {
    const { t } = useTranslation();
    return (
        <>
            <Title withMargin>{t("cargoFields.document_section.heading")}</Title>
            <FormRow>
                <div>
                    <FormikDropzoneField name="document" filesCount="10" />
                </div>
                <div className="add__block-half">
                    <span className="add__sub-info">
                        {t("cargoFields.document_section.add_file_note1")}
                        <br />
                        {t("cargoFields.document_section.add_file_note2")}
                    </span>
                </div>
            </FormRow>
        </>
    );
}
